import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row.exclusions');

const ExcludeCurrentJobPeopleCheckbox = () => {
  const { watch, setValue } = useFormContext();
  const exclude = watch('exclude_current_job_people');

  return (
    <Checkbox
      data-provides={'talent-matching-exclude-current-job-people-checkbox'}
      checked={exclude}
      onChange={(checked) =>
        setValue('exclude_current_job_people', checked, { shouldDirty: true })
      }
      label={t('candidates_or_prospects_on_this_job')}
      value={'exclude_current_job_people'}
      helperText={t('candidates_or_prospects_on_this_job_helper_text')}
    />
  );
};

export default ExcludeCurrentJobPeopleCheckbox;
